(function($){
    // The instatiation is based on the toggle button.
    /*eslint new-cap: 0*/
    $('.off-canvas__toggle').SquizOffCanvas();
}(jQuery));
